import React, { useEffect } from 'react';
import { NavigationBreadcrumbs } from '@sumtotal/react-foundation';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useSettingsContext from '../../hooks/useSettingsContext';
import useBreadcrumbContext from '../../hooks/useBreadcrumbContext';
import { setPageTitleWithBreadcrumbData } from '../../../utils/pageHelper';
import { IntegrationElement } from '../../../utils/IntegrationConstants';
import useIntegrationContext from '../../hooks/useIntegrationContext';
import CheckIntegrationSetting from '../../../utils/integrationHelper';

const StyledBreadcrumbs = styled(NavigationBreadcrumbs)`
  padding-top: 1rem;
  padding-left: 1rem;
`;

const getSettingValueFromContext = (settingContext, settingKey) => {
  if (settingContext && settingContext.settings) {
    const settingObj = settingContext.settings.filter((setting) => setting.key === settingKey)[0];
    return settingObj.value;
  }
  return null;
};

function Breadcrumbs() {
  const { settingsData } = useSettingsContext();
  const { breadcrumbContext } = useBreadcrumbContext();
  const breadcrumbsEnabled = getSettingValueFromContext(
    settingsData,
    'ELIXHRUI_GENERAL_SHOW_NAVIGATION_BREADCRUMBS'
  );
  const { t } = useTranslation(['TRANSLATIONS_RCORE_COMMON']);
  const { integrationContext } = useIntegrationContext();

  useEffect(() => {
    if (breadcrumbContext.breadcrumbData.length > 0)
      setPageTitleWithBreadcrumbData(breadcrumbContext.breadcrumbData);
  }, [breadcrumbContext.breadcrumbData]);

  if (
    breadcrumbsEnabled !== null &&
    breadcrumbsEnabled.toLowerCase() === 'true' &&
    breadcrumbContext.isRcoreNode &&
    CheckIntegrationSetting(IntegrationElement.HideBreadCrumb, integrationContext.mode) &&
    breadcrumbContext.breadcrumbData &&
    breadcrumbContext.breadcrumbData.length > 0
  ) {
    return (
      <>
        <StyledBreadcrumbs
          breadCrumbsData={breadcrumbContext.breadcrumbData}
          homeIconLabel={t('TRANSLATIONS_RCORE_COMMON:RCORE_HOME_TEXT')}
          navAriaLabel={t('TRANSLATIONS_RCORE_COMMON:RCORE_BREADCRUMB_TEXT')}
        />
      </>
    );
  }
  return null;
}

export default Breadcrumbs;
